import axios from "axios";
import { useEffect, useState } from "react";

const GetAccountStatusData = ({onStatusChange, selectedStatus, totalAccounts, accountStatusCount}) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);

    const handleStatusCLick = (status) => {
        const newStatus = selectedStatus === status ? null : status;
        onStatusChange(newStatus);
    };
    return(
        <div className="bg-white flex flex-col item-start shadow-lg rounded-lg p-4 mb-4 w-full h-fit">
            <h1 className="font-bold">All Total Accounts ({totalAccounts})</h1>
            <div className="flex flex-row justify-between">
                <div 
                    onClick={() => handleStatusCLick('Activated')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-28 flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Activated' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Activated</h3>
                        <a> &lt; 30 days </a>
                    </div>
                    <span className="text-xl font-bold">{accountStatusCount.find(item => item.churn_profile === 'Activated')?.count || ""}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Sirius')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-28 flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Sirius' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Sirius</h3>
                        <a>30 days &lt; Sirius &lt; 50 days</a>
                    </div>
                    <span className="text-xl font-bold">{accountStatusCount.find(item => item.churn_profile === 'Sirius')?.count || ""}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Spica')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-28 flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Spica' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Spica</h3>
                        <a>50 days &lt; Spica &lt; 70 days</a>
                    </div>
                    <span className="text-xl font-bold">{accountStatusCount.find(item => item.churn_profile === 'Spica')?.count || ""}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Sargas')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-28 flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Sargas' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Sargas</h3>
                        <a>70 days &lt; Sargas &lt; 90 days</a>
                    </div>
                    <span className="text-xl font-bold">{accountStatusCount.find(item => item.churn_profile === 'Sargas')?.count || ""}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Sabik')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-28 flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Sabik' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Sabik</h3>
                        <a>90 days &lt; Sabik &lt; 365 days</a>
                    </div>
                    <span className="text-xl font-bold">{accountStatusCount.find(item => item.churn_profile === 'Sabik')?.count || ""}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Dormant')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-28 flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Dormant' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Dormant</h3>
                        <a>&gt; 365 days</a>
                    </div>
                    <span className="text-xl font-bold">{accountStatusCount.find(item => item.churn_profile === 'Dormant')?.count || ""}</span>
                </div>
            </div>
        </div>
    )
}

export default GetAccountStatusData;